module.exports = __webpack_public_path__ + "img/mastercard.ee5c9d3f.svg";